import ExtendedPath from "csi/core/ExtendedPath";
import locale from "csi/locale";
import reflection from "csi/reflection";

/**
 * Get a localized path of names for the relation path.
 */
export function getLocalizedDomainRelationPath(ep: ExtendedPath): string {
	const n = ep.depth;

	if (!n) {
		return "";
	}

	const validSteps = [];
	for (let i = 0; i < n; i++) {
		const rcr = ep.getStepRelation(i);

		if (!rcr) {
			continue;
		}

		const name = rcr.getId();

		const sourceType = ep.getStartTypeFromStep(i);

		if (rcr.isSecondary || reflection.getRelationToSecondary(sourceType, name)) {
			continue;
		}

		validSteps.push(locale.typeId(ep.getStartTypeFromStep(i), name));
	}

	return validSteps.join(" / ");
};